








$(document).ready(function() {



/* =========================================================
   IVA SELECT — STABLE WITH DAWN SECTION RERENDER
   What it solves:
   - Variant change wipes your column HTML
   - Value disappears because new HTML is inserted
   - Dropdown stops working because old nodes are gone
========================================================= */

(function () {
  // ---------- helpers ----------
  function closestWrap(node) {
    return node && node.closest
      ? node.closest('.select.iva-select[data-iva-select]')
      : null;
  }

  function parts(wrap) {
    if (!wrap) return {};
    return {
      native: wrap.querySelector('select'),
      trigger: wrap.querySelector('.iva-select__trigger'),
      valueEl: wrap.querySelector('[data-iva-select-value]'),
      menu: wrap.querySelector('[data-iva-select-menu]'),
    };
  }

  function labelFromNative(native) {
    if (!native) return '';
    const v = native.value;
    const opt =
      (native.selectedOptions && native.selectedOptions[0]) ||
      Array.from(native.options).find(o => o.value === v) ||
      native.options[0] ||
      null;

    const txt = opt ? (opt.textContent || opt.text || '').trim() : '';
    return txt || (v || '').trim();
  }

  function syncValue(wrap) {
    const { native, valueEl } = parts(wrap);
    if (!native || !valueEl) return;

    const txt = labelFromNative(native);
    if (!txt) return; // never wipe
    valueEl.textContent = txt;
  }

  function buildMenu(wrap) {
    const { native, menu } = parts(wrap);
    if (!native || !menu) return;

    menu.innerHTML = '';
    const selectedValue = native.value;

    Array.from(native.options).forEach(opt => {
      const item = document.createElement('div');
      item.className = 'iva-opt';
      item.setAttribute('role', 'option');
      item.dataset.value = opt.value;
      item.setAttribute('aria-selected', opt.value === selectedValue ? 'true' : 'false');
      item.textContent = (opt.textContent || opt.text || '').trim(); // keeps " - Made to Order"
      menu.appendChild(item);
    });
  }

  function open(wrap) {
    if (!wrap) return;
    syncValue(wrap);
    buildMenu(wrap);
    wrap.classList.add('is-open');
    const { trigger } = parts(wrap);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function close(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-open');
    const { trigger } = parts(wrap);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAll(exceptWrap) {
    document.querySelectorAll('.select.iva-select[data-iva-select].is-open').forEach(w => {
      if (exceptWrap && w === exceptWrap) return;
      close(w);
    });
  }

  // Refresh all IVA selects under a given root
  function refresh(root) {
    const scope = root || document;
    scope.querySelectorAll('.select.iva-select[data-iva-select]').forEach(wrap => {
      syncValue(wrap);
      // Only build menu if open (keeps it light)
      if (wrap.classList.contains('is-open')) buildMenu(wrap);
    });
  }

  // ---------- delegated interactions ----------
  document.addEventListener('click', (e) => {
    const t = e.target;

    // Trigger toggles menu
    const trigger = t.closest && t.closest('.iva-select__trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();

      const wrap = closestWrap(trigger);
      if (!wrap) return;

      if (wrap.classList.contains('is-open')) close(wrap);
      else {
        closeAll(wrap);
        open(wrap);
      }
      return;
    }

    // Option click selects
    const optEl = t.closest && t.closest('.iva-opt');
    if (optEl) {
      const wrap = closestWrap(optEl);
      if (!wrap) return;

      const { native, valueEl } = parts(wrap);
      if (!native) return;

      // Immediate UI update from clicked label
      const nextLabel = (optEl.textContent || '').trim();
      if (valueEl && nextLabel) valueEl.textContent = nextLabel;

      native.value = optEl.dataset.value;
      native.dispatchEvent(new Event('change', { bubbles: true }));

      // Close now; Dawn may rerender afterwards
      close(wrap);
      return;
    }

    // Outside click closes
    closeAll(null);
  });

  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLSelectElement)) return;

    const wrap = closestWrap(el);
    if (!wrap) return;

    // Sync immediately for the current DOM…
    syncValue(wrap);

    // …and then let the observer refresh after Dawn swaps HTML
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll(null);
  });

  // ---------- observe Dawn rerenders (scoped, safe) ----------
  function observeProductInfo() {
    // Your container id looks like: ProductInfo-template--...__main
    const productInfo =
      document.querySelector('[id^="ProductInfo-template--"]') ||
      document.querySelector('.product__info-container');

    if (!productInfo) return;

    // Avoid double observers
    if (productInfo.dataset.ivaObserved === '1') return;
    productInfo.dataset.ivaObserved = '1';

    const obs = new MutationObserver((mutations) => {
      // If variant-selects or our select wrapper is replaced, refresh
      for (const m of mutations) {
        if (m.type !== 'childList') continue;

        const changed =
          Array.from(m.addedNodes).some(n =>
            n.nodeType === 1 && (
              n.matches?.('variant-selects') ||
              n.querySelector?.('variant-selects') ||
              n.matches?.('.select.iva-select[data-iva-select]') ||
              n.querySelector?.('.select.iva-select[data-iva-select]')
            )
          );

        if (changed) {
          // Next tick: DOM is settled
          requestAnimationFrame(() => refresh(productInfo));
          break;
        }
      }
    });

    obs.observe(productInfo, { childList: true, subtree: true });

    // Initial
    refresh(productInfo);
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductInfo);
  } else {
    observeProductInfo();
  }
  document.addEventListener('shopify:section:load', observeProductInfo);
})();






  
document.addEventListener("click", function (e) {
    const card = e.target.closest('[id*="__featured_collection"] .card-wrapper');
    if (!card) return;

    // If user clicked something already interactive, do not hijack it
    if (e.target.closest("a, button, input, textarea, select, summary")) return;

    // Prefer the main product link
    const link =
      card.querySelector('a[id^="CardLink-"]') ||
      card.querySelector("a.full-unstyled-link");

    if (link && link.href) window.location.href = link.href;
  });


  
    $('#ask-question-popup #ContactForm').on('submit', function(event) { 
        let isValid = true;
        
        // Remove error classes from all required fields
        $('input, textarea').removeClass('input-error');

        // Check each required field
        $('input, textarea').each(function() {
            if ($.trim($(this).val()) === '') {
                isValid = false;
                $(this).addClass('input-error');
                console.log('Invalid field:', $(this).attr('id'));
            }else{
             isValid = true;
            }
        });

        // If the form is invalid, prevent the default form submission
        if (!isValid) {
            event.preventDefault();
        }else{
          return true;
        }
    });
  
// contact Popup
    $('#ask-question-button').click(function(event) {
        event.preventDefault();   // Prevent the default action of the <a> tag
        event.stopPropagation();  // Prevent click event from propagating
        $('#ask-question-popup').fadeIn();  // Use fadeIn to make the popup visible
        $('body').addClass('no-scroll');  // Add no-scroll class to body
    });
    
    // Close Popup when clicking on the close button
    $('#popup-close').click(function(event) {
        event.stopPropagation();
        $('#ask-question-popup').fadeOut();  // Use fadeOut to hide the popup
        $('body').removeClass('no-scroll');  // Remove no-scroll class from body
    });
    
    // Close Popup when clicking outside the popup content area
    $('#ask-question-popup').click(function(event) {
        if (event.target === this) {
            $(this).fadeOut();
            $('body').removeClass('no-scroll');  // Remove no-scroll class from body
        }
    });
    
    // Prevent the popup from closing when clicking inside the content area
    $('.popup-content').click(function(event) {
        event.stopPropagation();
    });


//share popup
   $('.share-popup').click(function(event) {
        event.preventDefault();   // Prevent the default action of the <a> tag
        event.stopPropagation();  // Prevent click event from propagating
        $('.popupp-overlay').fadeIn();  // Use fadeIn to make the popup visible
     $('body').addClass('no-scroll');
     console.log(1);
    });

    // Close Popup when clicking on the close button
    $('.popupp-close').click(function(event) {
        event.stopPropagation();
        $('.popupp-overlay').fadeOut();  // Use fadeOut to hide the popup
    });

    // Close Popup when clicking outside the popup content area
    $('.popupp-overlay').click(function(event) {
        if (event.target === this) {
            $(this).fadeOut();
          $('body').removeClass('no-scroll');
        }
    });

    // Prevent the popup from closing when clicking inside the content area
    $('.popupp-content').click(function(event) {
        event.stopPropagation();
    });

      $('#copy-url-button').on('click', function() {
        // Get the current URL
        var url = window.location.href;

        // Create a temporary input element
        var $tempInput = $('<input>');
        $tempInput.val(url);
        $('body').append($tempInput);

        // Select the text field and copy the text inside it
        $tempInput.select();
        $tempInput[0].setSelectionRange(0, 99999); // For mobile devices
        document.execCommand('copy');

        // Remove the temporary input element
        $tempInput.remove();

        // Show the confirmation message
        var $statusElement = $('.copy-url-status');
        $statusElement.css('display', 'block');

        // Hide the confirmation message after a short delay
        setTimeout(function() {
            $statusElement.css('display', 'none');
        }, 2000);
    });

    const anchors = $('.menu-drawer__navigation a[href^="#"]');
      anchors.on('click', function(event) {
          $('.section-header').removeClass('menu-open');
          $('.dd-index').removeClass('overflow-hidden-tablet');
          $('.menu-drawer-container').removeClass('menu-opening');
          $('.menu-drawer-container').removeAttr('open');
          $('.header__icon--menu').attr('aria-expanded', 'false');
          event.preventDefault();

          const targetId = $(this).attr('href').substring(1);
          const targetElement = $('#' + targetId);

          if (window.location.pathname === '/') {
              if (targetElement.length) {
                  $('html, body').animate({
                      scrollTop: targetElement.offset().top
                  }, 'smooth');
              }
          } else {
              window.location.href = '/#' + targetId;
          }
      });

      $(function() {
        $('.header__inline-menu a[href^="#"]').on('click', function(e) {
          e.preventDefault();
            var headerHeight = $('sticky-header').outerHeight();
          $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - headerHeight
          }, 500, 'linear');
        });
      });
   
});


// vertical scroll in about-us page (max-width:1190px) screen

document.addEventListener('DOMContentLoaded', function() {
  const content = document.querySelector('.about_us_iva .rte.scroll-trigger.animate--slide-in');

  function applyScrolling() {
    const width = window.innerWidth;

    if (width > 1190) {
      // For screens wider than 1190px: enable scrolling
      content.style.maxWidth = '498px'; 
      content.style.height = '296px'; 
      content.style.overflowY = 'auto'; 
      content.style.overflowX = 'hidden'; 
    } else {
      // For screens narrower than 1190px: no scrolling
      content.style.maxWidth = '100%'; 
      content.style.height = '100%';
      content.style.overflowY = 'hidden'; 
      content.style.overflowX = 'hidden'; 
    }
  }

  if(content){
    applyScrolling();
    window.addEventListener('resize', applyScrolling); 
  }

// vertical scroll in about-us page end


// size guide popup

  const table = document.querySelector('.main-table');
  const chooseSize = document.getElementById('chooseSize');
  const middleIndex = Math.floor(table.rows[0].cells.length / 2);

  const getLeftOffset = () => {
    const width = window.innerWidth;
    if (width >= 320 && width <= 1024) return -10;
    if (width <= 1100) return -60;
    if (width <= 1300) return -50;
    if (width <= 1500) return -70;
    if (width <= 1700) return -80;
    return -100; // Default for desktop
  };

  const updateChooseSizePosition = (columnCells) => {
    const cellRect = columnCells[0].getBoundingClientRect();
    chooseSize.style.display = 'none';
    chooseSize.style.left = `${cellRect.left + cellRect.width / 2 - chooseSize.offsetWidth / 2 + getLeftOffset()}px`;
  };

  const highlightColumn = (index) => {
    removeAllColumnHighlights();
    const columnCells = document.querySelectorAll(`.main-table td:nth-child(${index + 1})`);
    columnCells.forEach((colCell) => colCell.classList.add('hovered-column'));
    updateChooseSizePosition(columnCells);
  };

  const removeAllColumnHighlights = () => {
    document.querySelectorAll('.hovered-column').forEach((colCell) => colCell.classList.remove('hovered-column'));
  };

  highlightColumn(middleIndex); // Initially highlight the middle column

  document.querySelectorAll('.main-table td').forEach((cell) => {
    cell.addEventListener('mouseover', () => {
      highlightColumn(cell.cellIndex);
    });

    cell.addEventListener('mouseout', () => {
      removeAllColumnHighlights();
      highlightColumn(middleIndex); // Revert to the middle column on mouse out
    });
  });

  window.addEventListener('resize', () => {
    highlightColumn(middleIndex); // Adjust positioning on window resize
  });
  
});





document.addEventListener('click', (e) => {
  const btn = e.target.closest('.iva-thumb[data-iva-media-num]');
  if (!btn) return;

  const numId = btn.dataset.ivaMediaNum; // "45310493032753"

  const gallery = btn.closest('product-info')?.querySelector('media-gallery')
    || document.querySelector('media-gallery');

  if (!gallery) return;

  const scroller = gallery.querySelector('#GalleryViewer-template--25793038057777__main')
    || gallery.querySelector('[id^="GalleryViewer"]'); // <slider-component>

  if (!scroller) return;

  // LI has: data-media-id="template--...-<numId>"
  const target = scroller.querySelector(`[data-media-id$="-${numId}"]`);
  if (!target) return;

  // Scroll inside slider-component (your CSS makes this the scroll container)
  const scrollerRect = scroller.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const nextTop = (targetRect.top - scrollerRect.top) + scroller.scrollTop;

  scroller.scrollTo({ top: nextTop, behavior: 'smooth' });

  // Update active state for thumbs
  document.querySelectorAll('.iva-thumb.is-active').forEach((b) => b.classList.remove('is-active'));
  btn.classList.add('is-active');

  // Optional: update active state for slides too (keeps Dawn classes consistent)
  scroller.querySelectorAll('.product__media-item.is-active').forEach((li) => li.classList.remove('is-active'));
  target.classList.add('is-active');
});


(() => {
  const THUMB_SEL = '.iva-thumb[data-iva-media-num]';
  const SLIDE_SEL = 'li.product__media-item[data-media-id]';

  const setActiveThumb = (num) => {
    document.querySelectorAll(THUMB_SEL).forEach((t) => {
      t.classList.toggle('is-active', t.dataset.ivaMediaNum === String(num));
    });
  };

  const getNumericIdFromSlide = (slideEl) => {
    const id = slideEl?.getAttribute('data-media-id') || '';
    return id.split('-').pop(); // last chunk is the numeric id
  };

  const findScrollParent = (el) => {
    let cur = el;
    while (cur && cur !== document.body) {
      const s = window.getComputedStyle(cur);
      const oy = s.overflowY;
      const canScroll = (oy === 'auto' || oy === 'scroll') && (cur.scrollHeight > cur.clientHeight + 2);
      if (canScroll) return cur;
      cur = cur.parentElement;
    }
    return document.scrollingElement; // fallback
  };

  const initThumbSync = () => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slides = Array.from(gallery.querySelectorAll(SLIDE_SEL));
    const thumbs = Array.from(document.querySelectorAll(THUMB_SEL));
    if (!slides.length || !thumbs.length) return;

    const scroller = findScrollParent(slides[0]);

    // debug (safe to keep)
    console.log('[IVA] slides:', slides.length, 'thumbs:', thumbs.length, 'scroller:', scroller);

    // Avoid double-binding if Shopify re-renders sections
    if (scroller.__ivaThumbObserverBound) return;
    scroller.__ivaThumbObserverBound = true;

    // 1) IntersectionObserver: pick the most visible slide inside the scroller
    const root = scroller === document.scrollingElement ? null : scroller;
    let raf = 0;

    const pickBest = (entries) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        let best = null;
        let bestRatio = 0;

        for (const e of entries) {
          if (!e.isIntersecting) continue;
          if (e.intersectionRatio > bestRatio) {
            bestRatio = e.intersectionRatio;
            best = e.target;
          }
        }

        // If nothing intersects (fast scroll), fallback to nearest by offset
        if (!best) {
          const y = (root ? scroller.scrollTop : window.scrollY);
          let nearest = null;
          let dist = Infinity;
          for (const s of slides) {
            const top = root ? s.offsetTop : (s.getBoundingClientRect().top + window.scrollY);
            const d = Math.abs(top - y);
            if (d < dist) { dist = d; nearest = s; }
          }
          best = nearest;
        }

        const num = getNumericIdFromSlide(best);
        if (num) setActiveThumb(num);
      });
    };

    const io = new IntersectionObserver(pickBest, {
      root,
      threshold: [0.35, 0.5, 0.65, 0.8],
      rootMargin: '0px 0px -55% 0px', // treat the “top half” as current
    });

    slides.forEach((s) => io.observe(s));

    // 2) Initial set
    const firstActive = slides.find((s) => s.classList.contains('is-active')) || slides[0];
    const num = getNumericIdFromSlide(firstActive);
    if (num) setActiveThumb(num);
  };

  // Run on load + after theme hydration
  document.addEventListener('DOMContentLoaded', initThumbSync);
  setTimeout(initThumbSync, 400);
  setTimeout(initThumbSync, 1200);
  document.addEventListener('shopify:section:load', initThumbSync);
})();




(function () {
  const THUMB_SELECTOR = '.iva-left-thumbs .iva-thumb[data-iva-media-num]';

  function getNumericMediaIdFromSlide(slideEl) {
    // slideEl.getAttribute('data-media-id') looks like: "template--...__main-45924456005937"
    const full = slideEl?.getAttribute?.('data-media-id') || '';
    const match = full.match(/(\d+)\s*$/);
    return match ? match[1] : null;
  }

  function setActiveThumb(galleryRoot, numericId) {
    if (!numericId) return;
    const thumbs = galleryRoot.querySelectorAll(THUMB_SELECTOR);
    thumbs.forEach((b) => b.classList.remove('is-active'));

    const active = galleryRoot.querySelector(`${THUMB_SELECTOR}[data-iva-media-num="${CSS.escape(numericId)}"]`);
    if (active) active.classList.add('is-active');
  }

  function scrollToSlide(sliderComponent, numericId) {
    if (!numericId) return;

    const ul = sliderComponent.querySelector('[id^="Slider-"]');
    if (!ul) return;

    // Match slide where data-media-id ends in "-<numericId>"
    const slide = ul.querySelector(`[id^="Slide-"][data-media-id$="-${CSS.escape(numericId)}"]`);
    if (!slide) return;

    ul.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  function wireOneGallery(mediaGalleryEl) {
    const sliderComponent = mediaGalleryEl.querySelector('slider-component');
    const ivaThumbWrap = mediaGalleryEl.closest('.grid__item')?.querySelector('.iva-left-thumbs')
      || document.querySelector('.iva-left-thumbs'); // fallback if your thumbs live outside

    // We need a single "root" that contains BOTH slider + thumbs to query within.
    // If thumbs live elsewhere, we still can update them via document queries.
    const root = document;

    if (!sliderComponent || !ivaThumbWrap) return;

    // 1) slider -> thumbs
    sliderComponent.addEventListener('slideChanged', (e) => {
      const slideEl = e.detail?.currentElement;
      const numericId = getNumericMediaIdFromSlide(slideEl);
      setActiveThumb(root, numericId);
    });

    // 2) initial highlight from currently active slide
    const activeSlide =
      sliderComponent.querySelector('.slider__slide.is-active') ||
      sliderComponent.querySelector('[id^="Slide-"]');
    const initialId = getNumericMediaIdFromSlide(activeSlide);
    setActiveThumb(root, initialId);

    // 3) thumbs -> slider
    root.addEventListener('click', (evt) => {
      const btn = evt.target.closest(THUMB_SELECTOR);
      if (!btn) return;

      const numericId = btn.getAttribute('data-iva-media-num');
      setActiveThumb(root, numericId);     // instant visual feedback
      scrollToSlide(sliderComponent, numericId);
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(wireOneGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();





/*
  IVA ESA — Mobile Description Toggle (v2)
  
  Creates a peek panel below the media gallery showing:
  - Product name + price
  - First few lines of description (fades out)
  - "SHOW DESCRIPTION" / "COLLAPSE DESCRIPTION" toggle
  
  On tap, expands to reveal full description + metafields.
*/

(function () {
  'use strict';

  if (window.matchMedia('(min-width: 990px)').matches) return;

  function init() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    var mediaWrapper = productInfo.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;

    // Source elements
    var titleEl = productInfo.querySelector('h1.product__title');
    var priceEl = productInfo.querySelector('.price-item--regular') ||
                  productInfo.querySelector('.price-item');
    var descEl  = productInfo.querySelector('.product__description.rte');
    var metaEl  = productInfo.querySelector('.product-metafields');

    // Need at least title or description
    if (!titleEl && !descEl) return;

    // ── Build the panel ──
    var panel = document.createElement('div');
    panel.className = 'iva-desc-panel';

    var inner = document.createElement('div');
    inner.className = 'iva-desc-panel__inner';

    // Title + price row
    if (titleEl || priceEl) {
      var titleRow = document.createElement('div');
      titleRow.className = 'iva-mobile-title';

      if (titleEl) {
        var nameSpan = document.createElement('span');
        nameSpan.className = 'iva-mobile-title__name';
        nameSpan.textContent = titleEl.textContent.trim();
        titleRow.appendChild(nameSpan);
      }

      if (priceEl) {
        var priceSpan = document.createElement('span');
        priceSpan.className = 'iva-mobile-title__price';
        priceSpan.textContent = priceEl.textContent.trim();
        titleRow.appendChild(priceSpan);
      }

      inner.appendChild(titleRow);
    }

    // SKU number
    var skuEl = productInfo.querySelector('.product__text.inline-richtext.caption-with-letter-spacing') ||
                productInfo.querySelector('.product__sku') ||
                productInfo.querySelector('[class*="sku"]');
    if (skuEl && skuEl.textContent.trim()) {
      var skuDiv = document.createElement('div');
      skuDiv.className = 'iva-mobile-sku';
      skuDiv.textContent = skuEl.textContent.trim().toUpperCase();
      inner.appendChild(skuDiv);

      // Hide the original on mobile
      skuEl.style.display = 'none';
    }

    // Description
    if (descEl) {
      var descClone = descEl.cloneNode(true);
      descClone.className = 'iva-mobile-desc';
      descClone.removeAttribute('style');
      inner.appendChild(descClone);
    }

    // Metafields
    if (metaEl) {
      var metaClone = metaEl.cloneNode(true);
      metaClone.className = 'iva-mobile-meta';
      inner.appendChild(metaClone);
    }

    panel.appendChild(inner);

    // ── Build the toggle button ──
    var toggle = document.createElement('button');
    toggle.className = 'iva-desc-toggle';
    toggle.type = 'button';
    toggle.innerHTML =
      '<span class="iva-desc-toggle__show">Show Description</span>' +
      '<span class="iva-desc-toggle__hide">Collapse Description</span>';

    // ── Insert after media wrapper ──
    mediaWrapper.insertAdjacentElement('afterend', panel);
    panel.insertAdjacentElement('afterend', toggle);

    // ── Toggle behavior ──
    toggle.addEventListener('click', function () {
      var isOpen = toggle.classList.toggle('is-open');
      panel.classList.toggle('is-open', isOpen);

      // Scroll the panel into view when opening
      if (isOpen) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    // ── Fix: prevent image shift after lightbox modal close ──
    // Dawn's modal close triggers focus/scrollIntoView on the opener element,
    // which shifts the image up. We fix this with multiple strategies:
    (function () {
      var savedScrollY = 0;
      var modalIsOpen = false;

      // Strategy 1: Save scroll position before modal opens
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('.product__modal-opener, .product__media-toggle, .product__media-icon, .product__media-zoom-lightbox, modal-opener');
        if (opener) {
          savedScrollY = window.scrollY || window.pageYOffset;
          modalIsOpen = true;
        }
      }, true);

      // Strategy 2: Override Element.prototype.focus temporarily during modal close
      // and block scrollIntoView on media items
      var origFocus = HTMLElement.prototype.focus;
      var origScrollIntoView = Element.prototype.scrollIntoView;
      var blockingScroll = false;

      function startBlocking() {
        blockingScroll = true;
        // Override focus to use preventScroll
        HTMLElement.prototype.focus = function (opts) {
          return origFocus.call(this, { preventScroll: true });
        };
        // Block scrollIntoView on product media elements
        Element.prototype.scrollIntoView = function () {
          if (this.closest && this.closest('.product__media-wrapper, .product__media-list, .product__media-item, media-gallery')) {
            return; // block it
          }
          return origScrollIntoView.apply(this, arguments);
        };
      }

      function stopBlocking() {
        blockingScroll = false;
        HTMLElement.prototype.focus = origFocus;
        Element.prototype.scrollIntoView = origScrollIntoView;
      }

      // Strategy 3: Watch for the modal close button click
      document.addEventListener('click', function (e) {
        var closeBtn = e.target.closest('.product-media-modal__toggle, product-modal .modal__close-button');
        if (closeBtn && modalIsOpen) {
          startBlocking();
          // Restore scroll position aggressively
          requestAnimationFrame(function () {
            window.scrollTo(0, savedScrollY);
            setTimeout(function () {
              window.scrollTo(0, savedScrollY);
              stopBlocking();
              modalIsOpen = false;
            }, 100);
          });
        }
      }, true);

      // Strategy 4: Also watch for Escape key closing the modal
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modalIsOpen) {
          startBlocking();
          requestAnimationFrame(function () {
            window.scrollTo(0, savedScrollY);
            setTimeout(function () {
              window.scrollTo(0, savedScrollY);
              stopBlocking();
              modalIsOpen = false;
            }, 100);
          });
        }
      }, true);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();